import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/lib/Col';
import Logo from '../../Logo';
import Classes from '../../../common/Classes';
import Utils from '../../../common/Utils';
import mixpanelConstants from '../../../common/mixpanelConstants';

const ExhibitorLogo = ({
  exhibitor, detailPageLink, defaultLogoUrl, tags, triggerMixpanelEvent
}) => (
  <Col className="image-column" data-testId='exh-logo'>
      <div className={Classes.imageContainer}
           onClick={() => triggerMixpanelEvent(mixpanelConstants.element.logo)}>
        <a
          href={detailPageLink}
          data-dtm={exhibitor.isPrioritySlotPremiumExhibitor ? tags.exhibitorLogo + tags.prioritySlot : tags.exhibitorLogo}
          data-dtm-attributes={
          JSON.stringify({ exhibitorId: exhibitor.id, package: Utils.getPackageName(exhibitor.packageId) })}
        >
          <Logo url={exhibitor.logo} name={exhibitor.name} defaultLogoUrl={defaultLogoUrl} />
        </a>
      </div>
  </Col>
);

ExhibitorLogo.propTypes = {
  detailPageLink: PropTypes.string.isRequired,
  exhibitor: PropTypes.shape({
    id: PropTypes.string.isRequired,
    logo: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
  defaultLogoUrl: PropTypes.string.isRequired,
  tags: PropTypes.shape({
    exhibitorName: PropTypes.string,
    prioritySlot: PropTypes.string
  }),
  triggerMixpanelEvent: PropTypes.func,
};

export default ExhibitorLogo;
